export default "__VITE_ASSET__Dh9DbdaI__"